import { prepareWorkflow } from './reducer';
import { put } from 'helpers/api';

export const ADD_STEP = 'ADD_STEP';
export function addStep() {
  return {
    type: ADD_STEP
  };
}

export const REMOVE_STEP = 'REMOVE_STEP';
export function removeStep(step) {
  return {
    type: REMOVE_STEP,
    step
  };
}

export const ADD_ASSIGNEE_GROUP = 'ADD_ASSIGNEE_GROUP';
export function addAssigneeGroup(step) {
  return {
    type: ADD_ASSIGNEE_GROUP,
    step
  };
}

export const CHANGE_ASSIGNEE_GROUP = 'CHANGE_ASSIGNEE_GROUP';
export function changeAssigneeGroup(step, assigneeGroup, changes) {
  return {
    type: CHANGE_ASSIGNEE_GROUP,
    assigneeGroup,
    changes,
    step
  };
}

export const REMOVE_ASSIGNEE_GROUP = 'REMOVE_ASSIGNEE_GROUP';
export function removeAssigneeGroup(step, assigneeGroup) {
  return {
    type: REMOVE_ASSIGNEE_GROUP,
    assigneeGroup,
    step
  };
}

export const ADD_ASSIGNEE = 'ADD_ASSIGNEE';
export function addAssignee(step, assigneeGroup) {
  return {
    type: ADD_ASSIGNEE,
    assigneeGroup,
    step
  };
}

export const CHANGE_ASSIGNEE = 'CHANGE_ASSIGNEE';
export function setAssigneeRole(step, assigneeGroup, assignee, role) {
  return {
    type: CHANGE_ASSIGNEE,
    assignee,
    assigneeGroup,
    step,
    changes: {
      role,
      user: null
    }
  };
}

export function setAssigneeUser(step, assigneeGroup, assignee, user) {
  return {
    type: CHANGE_ASSIGNEE,
    assignee,
    assigneeGroup,
    step,
    changes: {
      role: null,
      user
    }
  };
}

export const REMOVE_ASSIGNEE = 'REMOVE_ASSIGNEE';
export function removeAssignee(step, assigneeGroup, assignee) {
  return {
    type: REMOVE_ASSIGNEE,
    assignee,
    assigneeGroup,
    step
  };
}

export const CHANGE_STEP_MODE = 'CHANGE_STEP_MODE';
export function changeStepMode(step, mode) {
  return {
    type: CHANGE_STEP_MODE,
    mode,
    step
  };
}

function buildStepAttributes(workflow, step) {
  const assigneeGroupsAttributes = [];

  for (const assigneeGroup of step.assigneeGroups) {
    assigneeGroupsAttributes.push(buildAssigneeGroupAttributes(assigneeGroup));
  }

  for (const assigneeGroup of step.assigneeGroupsToDelete) {
    assigneeGroupsAttributes.push({
      id: assigneeGroup.id,
      _destroy: true
    });
  }

  return {
    assigneeGroupsAttributes,
    id: step.id,
    mode: step.mode,
    sortOrder: step.index,
    type: workflow.stepType
  };
}

function buildAssigneeGroupAttributes(assigneeGroup) {
  const assigneesAttributes = [];

  for (const assignee of assigneeGroup.assignees) {
    assigneesAttributes.push({
      id: assignee.id,
      role: assignee.role ? assignee.role.value : null,
      userId: assignee.user ? assignee.user.id : null
    });
  }

  for (const assignee of assigneeGroup.assigneesToDelete) {
    assigneesAttributes.push({
      id: assignee.id,
      _destroy: true
    });
  }

  return {
    id: assigneeGroup.id,
    assigneesAttributes,
    mode: assigneeGroup.mode
  };
}

export const WORKFLOW_SAVE_STARTED = 'WORKFLOW_SAVE_STARTED';
export function saveWorkflow() {
  return (dispatch, getState) => {
    const { workflow } = getState();

    const stepsAttributes = [];

    for (const step of workflow.steps) {
      stepsAttributes.push(buildStepAttributes(workflow, step));
    }

    for (const step of workflow.stepsToDelete) {
      stepsAttributes.push({
        id: step.id,
        _destroy: true
      });
    }

    const body = {
      taskWorkflow: {
        stepsAttributes,
        type: workflow.type
      }
    };

    dispatch({ type: WORKFLOW_SAVE_STARTED });
    return put(workflow.path, body)
      .then(workflow => dispatch(setWorkflow({ ...workflow, saved: true })))
      .catch(errors => dispatch(setErrors(errors)));
  };
}

export const SET_WORKFLOW = 'SET_WORKFLOW';
function setWorkflow(workflow) {
  return {
    type: SET_WORKFLOW,
    workflow: prepareWorkflow(workflow)
  };
}

export const SET_WORKFLOW_ERRORS = 'SET_WORKFLOW_ERRORS';
function setErrors(errors) {
  return {
    type: SET_WORKFLOW_ERRORS,
    errors
  };
}

export const CLEAR_WORKFLOW_SAVED = 'CLEAR_WORKFLOW_SAVED';
export function clearWorkflowSaved() {
  return {
    type: CLEAR_WORKFLOW_SAVED
  };
}
